import React, { useState } from 'react';

import SpecialsBox from '../../component/SpecialsBox';
import { IoMdHeartEmpty, IoMdShareAlt } from 'react-icons/io';
import ImageCarousel from 'component/ImageCarousel';
import IntroductionBanner from 'component/IntroductionBanner';
import FrameL from 'component/FrameL';

export default ({ cmsData, AmpPackages = [] }) => {
    let { HeroImage, RomanceBanner = {}, HoneymoonBanner = {}, PromotionsBanner = {}, GiftCertificateBanner = {} } = cmsData;

    PromotionsBanner = PromotionsBanner || {};

    const Promotions = AmpPackages.filter(a => a.category === 'regular');
    const Romance = AmpPackages.filter(a => a.category === 'romance');
    const Honeymoon = AmpPackages.filter(a => a.category === 'honeymoon');

    return <stack-l space="var(--s4)" class="xl:container mx-auto px-4 pb-10" aria-label="Packages Page" role="main">
        <div className="relative break-out-banner">
            <ImageCarousel ratio="16:9">
                {HeroImage.map((Image, i) => {
                    return <FrameL ratio="16:9" Image={Image}></FrameL>
                })}
            </ImageCarousel>
            <h1 className="page-title text-6xl text-white">Packages</h1>
        </div>

        <IntroductionBanner className="break-out-banner" cmsData={RomanceBanner} />

        <grid-l min="400px" space="var(--s2)" class="w-full">
            {Romance.map((special, i) => {
                return <SpecialsBox
                    key={i}
                    cmsData={special} />
            })}
        </grid-l>

        <IntroductionBanner className="break-out-banner" cmsData={HoneymoonBanner} />

        <grid-l min="400px" space="var(--s2)" class="w-full">
            {Honeymoon.map((special, i) => {
                return <SpecialsBox
                    key={i}
                    cmsData={special} />
            })}
        </grid-l>

        <IntroductionBanner className="break-out-banner" cmsData={PromotionsBanner} />

        <grid-l min="400px" space="var(--s2)" class="w-full">
            {Promotions.map((special, i) => {
                return <SpecialsBox
                    key={i}
                    cmsData={special} />
            })}
        </grid-l>

        <IntroductionBanner className="break-out-banner" cmsData={GiftCertificateBanner} />
    </stack-l>
}